import React from 'react'
import Slider from 'react-slick'
import {Icon, Grid, CircularProgress} from '@material-ui/core'

import './PropertyPics.css'
import {loadImages} from '../../../../actions/mediaActions'
import InfoHeader from "../Information/InfoHeader"

import 'aframe'
import { Entity, Scene } from 'aframe-react'

const PrevArrow = ({currentSlide, slideCount, onClick, ...props}) => (
    <button onClick={onClick} className={['slick-prev', 'prevBut'].join(' ')}>
        <Icon color={'secondary'} fontSize={'large'}>keyboard_arrow_left</Icon>
    </button>
)

const NextArrow = ({currentSlide, slideCount, ...props}) => (
    <button {...props} className={['slick-next', 'nextBut'].join(' ')}>
        <Icon color={'secondary'} fontSize={'large'}>keyboard_arrow_right</Icon>
    </button>
)

const styles = {
    loading: {
        position: 'fixed',
        zIndex: 300,
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, .7)'
    }
}

class PropertyPics extends React.Component {
    state = {
        currentImage: 0,
        images: [],
        loading: false
    }

    updateImage = (i) => {
        this.setState({
            currentImage: i
        })
    }

    async componentDidMount() {
        if (this.props.residence && this.props.residence.files) {
            console.log(this.props.residence.files)
            const images = await loadImages(this.props.residence.files)
            this.setState({
                images
            })
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.residence !== this.props.residence) {
            if (this.props.residence && this.props.residence.files) {
                const images = await loadImages(this.props.residence.files)
                this.setState({
                    images
                })
            }
        }
    }

    render = () => {
        const settings = {
            dots: false,
            infinite: true,
            speed: 200,
            slidesToShow: this.state.images.length < 4 ? this.state.images.length : 4,
            row: 1,
            centerMode: true,
            arrows: true,
            centerPadding: '100px',
            adaptHeight: true,
            prevArrow: <PrevArrow/>,
            nextArrow: <NextArrow/>,
            className: 'slider',
            beforeChange: (oldIndex, newIndex) => this.updateImage(newIndex)
        }

        let panorama = false
        try {
            if(this.state.images.length > 0) {
                const url = this.state.images[this.state.currentImage].split('production/')[1].split('?')[0]
                if(url.substring(url.length-4) === '_360' ) {
                    panorama = true
                }
            }
        } catch (e) {
            console.error(e)
        }

        return (
            <div>
                {this.state.loading &&
                    <div style={styleMedia.loading} ><CircularProgress /></div>
                }
                <InfoHeader>
                    {this.props.title || ""}
                </InfoHeader>
                {this.state.images.length > 0 && (
                    <div>
                        <Grid container
                              alignItems='center'
                              justify='center'
                              style={{height: '20em'}}
                        >
                            {panorama
                                ? <Scene embedded events={{
                                    loaded: () => this.setState({loading: false})
                                }} >
                                    <Entity camera look-controls="reverseMouseDrag: true" />
                                    <Entity primitive='a-assets' >
                                        <img id="aframe_img" crossOrigin="anonymous" alt='property' src={this.state.images[this.state.currentImage]} />
                                    </Entity>
                                    <Entity primitive='a-sky' src="#aframe_img" />
                                </Scene>
                                : <img src={this.state.images.length > 0 && this.state.images[this.state.currentImage]}
                                    alt={'residence'}
                                    className="image"
                                />
                            }
                        </Grid>
                        <Slider {...settings} >
                            {this.state.images.map((pic, i) => 
                                <div
                                    key={i}
                                    className="slideimage-container"
                                    onClick={() => this.updateImage(i)}  
                                >
                                    <img
                                        className="slideimage"
                                        src={pic}
                                        alt='property-slide'
                                    />
                                </div>
                            )}
                        </Slider>
                    </div>)}
            </div>
        )
    }
}

export default PropertyPics